import { aceSectionCssVariables } from "./ace-section.get-names";
import { aceSectionSlots } from "./ace-section.get-names";
import { getAceSectionNames } from "./ace-section.get-names";
import { h, Host } from "@stencil/core";
import { getInlineCssColor, getProperty, hasSlot, JsonParser } from "../../utils";
export class AceSection {
    constructor() {
        this.backgroundColor = 'surface-solid--100';
        this.backgroundSrc = undefined;
        this.withOverlay = false;
        this.withBlur = false;
        this.lazy = true;
        this.customOuterGutter = undefined;
        this.withPaddingTop = true;
        this.withPaddingBottom = true;
        this.fullWidthMobile = false;
        this.fullWidthTablet = false;
    }
    componentWillLoad() {
        var _a;
        this.names = getAceSectionNames((_a = this.hostElement) === null || _a === void 0 ? void 0 : _a.id);
        this._backgroundColor = getInlineCssColor(this.backgroundColor);
        this.parseOuterGutter();
    }
    parseOuterGutter() {
        this._customOuterGutter = new JsonParser(this.customOuterGutter, {}).getValue();
    }
    renderHeader() {
        if (!hasSlot(this.hostElement, aceSectionSlots.TITLE)) {
            return;
        }
        return (h("div", { class: this.names.CLASS.HEADER }, h("slot", { name: aceSectionSlots.TITLE })));
    }
    getGutterCssVariables() {
        return Object.fromEntries([
            [aceSectionCssVariables.OUTER_GUTTER__MOBILE, getProperty(this._customOuterGutter, 'mobile')],
            [aceSectionCssVariables.OUTER_GUTTER__TABLET, getProperty(this._customOuterGutter, 'tablet')],
            [aceSectionCssVariables.OUTER_GUTTER__DESKTOP, getProperty(this._customOuterGutter, 'desktop')],
        ].filter(([, value]) => value !== undefined));
    }
    renderSection() {
        const classes = {
            [this.names.CLASS.ROOT]: true,
            [this.names.CLASS.____WITH_PADDING_TOP]: this.withPaddingTop,
            [this.names.CLASS.____WITH_PADDING_BOTTOM]: this.withPaddingBottom,
            [this.names.CLASS.____FULL_WIDTH_MOBILE]: this.fullWidthMobile,
            [this.names.CLASS.____FULL_WIDTH_TABLET]: this.fullWidthTablet,
        };
        return (h("section", { class: classes }, this.renderHeader(), h("slot", null), h("slot", { name: aceSectionSlots.FOOTER })));
    }
    render() {
        const styles = Object.assign({ [aceSectionCssVariables.BACKGROUND_COLOR]: this._backgroundColor }, this.getGutterCssVariables());
        if (this.backgroundSrc) {
            return (h("ace-background-image", { src: this.backgroundSrc, withOverlay: this.withOverlay, withBlur: this.withBlur, style: styles, lazy: this.lazy }, this.renderSection()));
        }
        // Why do we need to set the id here? This actully results in overwriting the id of component in the main HTML
        return (h(Host, { id: this.names.ID.ROOT, style: styles }, this.renderSection()));
    }
    static get is() { return "ace-section"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["./ace-section.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ace-section.css"]
        };
    }
    static get properties() {
        return {
            "backgroundColor": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "background-color",
                "reflect": false,
                "defaultValue": "'surface-solid--100'"
            },
            "backgroundSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "background-src",
                "reflect": false
            },
            "withOverlay": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "with-overlay",
                "reflect": false,
                "defaultValue": "false"
            },
            "withBlur": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "with-blur",
                "reflect": false,
                "defaultValue": "false"
            },
            "lazy": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "lazy",
                "reflect": false,
                "defaultValue": "true"
            },
            "customOuterGutter": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IAceSectionCustomOuterGutter | string",
                    "resolved": "string | { mobile?: string; tablet?: string; desktop?: string; }",
                    "references": {
                        "IAceSectionCustomOuterGutter": {
                            "location": "import",
                            "path": "./ace-section.types",
                            "id": "src/components/ace-section/ace-section.types.ts::IAceSectionCustomOuterGutter"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "custom-outer-gutter",
                "reflect": false
            },
            "withPaddingTop": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "with-padding-top",
                "reflect": false,
                "defaultValue": "true"
            },
            "withPaddingBottom": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "with-padding-bottom",
                "reflect": false,
                "defaultValue": "true"
            },
            "fullWidthMobile": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "full-width-mobile",
                "reflect": false,
                "defaultValue": "false"
            },
            "fullWidthTablet": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "full-width-tablet",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get elementRef() { return "hostElement"; }
    static get watchers() {
        return [{
                "propName": "customOuterGutter",
                "methodName": "parseOuterGutter"
            }];
    }
}
//# sourceMappingURL=ace-section.js.map
